"use client";

import {
  InputGroup,
  InputGroupAddon,
  InputGroupInput,
} from "@tillix/ui-atoms/input-group";
import { cn } from "@tillix/ui-atoms/lib/utils";
import { SearchIcon } from "lucide-react";
import { useT } from "@/features/i18n/hooks/use-t";
import { topicLabelKeys, topics } from "./faqData";
import type { FAQTopic } from "./faqData";

interface SupportSidebarProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  activeTopic: FAQTopic | "all";
  setActiveTopic: (topic: FAQTopic | "all") => void;
}

export default function SupportSidebar({
  searchQuery,
  setSearchQuery,
  activeTopic,
  setActiveTopic,
}: SupportSidebarProps) {
  const { t } = useT();

  return (
    // Filter Input
    <div className="mb-8 hidden w-[17rem] flex-col gap-4 md:flex">
      <InputGroup>
        <InputGroupAddon align="inline-start">
          <SearchIcon className="size-4" />
        </InputGroupAddon>
        <InputGroupInput
          onChange={(e) => setSearchQuery(e.target.value)}
          placeholder={t("faq.searchPlaceholder")}
          value={searchQuery}
        />
      </InputGroup>

      {/* Topic Filter */}
      <div className="mb-8">
        <div className="flex flex-col gap-4 pb-2">
          <p className="pl-4 text-sm">{t("faq.topic")}</p>
          {topics.map((topic) => (
            <button
              className={cn(
                "border-l-2 px-4 py-0 text-left transition-colors duration-300",
                activeTopic === topic
                  ? "border-tenant-howard-county-primary-primary-blue text-tenant-howard-county-primary-primary-blue"
                  : "border-transparent text-muted-foreground hover:text-tenant-howard-county-primary-primary-blue",
              )}
              key={topic}
              onClick={() => setActiveTopic(topic)}
              type="button"
            >
              {t(topicLabelKeys[topic])}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
